export default __webpack_public_path__ + "static/media/img11.499e3801.webp";